<template>
    <li class="ath-list-el-item f fa-c sp-s br-s u-us-n"
        @click.stop.prevent="onItemClicked"
        :class="[item.active ? 'el-active' : '']"
        :qa="item.qa_tag">
        <Icon v-if="item.icon" :name="item.icon" uiSize="xxl" class="sm-r-s" />
        <div class="f fv">
            <span>{{ item.label }}</span>
            <span v-if="item.hasSubtitle" class="te-subnote">{{ item.subtitle }}</span>
        </div>
    </li>
</template>
<script>
import Icon from '../../atoms/visuals/Icon.vue';

export default {
    components: {Icon},
    props: {
        /**
         * The list item to render, expected to expose label, an optional icon,
         * an optional subtitle (shown when hasSubtitle is true), an active flag
         * for highlighting, an optional qa_tag, and an onClick handler invoked
         * when the item is clicked.
         */
        item: {type: Object, default: () => {}}
    },
    methods: {
        onItemClicked: function () {
            this.item.onClick();
            this.$emit('onClick');
        }
    }
}
</script>
<style lang="scss">
@use '../../../../sass/variables' as *;

.ath-list-el-item {

    cursor: pointer;
    line-height: $lh-s;

    span {
        text-overflow: ellipsis;
        word-wrap: break-word;
    }

    &:hover {
        background: var(--c-brand-default-bg);
    }

    &.el-active,
    &:active {
        background: var(--c-brand-active-bg);
        color: var(--c-brand-active-fg);
    }
}
</style>